
import * as THREE from 'three'

export default ( camera: THREE.PerspectiveCamera, container: HTMLElement ) => {
  let binds: any[] = []

  return ({
    bindPos: (point: any, cb: Function) => {
      binds = []

      binds.push({
        point,
        cb
      })
    },
    update: (b: Boolean) => {
      binds.forEach(({point, cb}) => {
        const vector = new THREE.Vector3();
        
        const vector3_projection = new THREE.Vector2( 
            container.clientWidth, 
            container.clientHeight 
        );

      
        const widthHalf = 0.5 * vector3_projection.x;
        const heightHalf = 0.5 * vector3_projection.y;
      
        point.updateMatrixWorld();
        vector.setFromMatrixPosition( point.matrixWorld );
        vector.project(camera);
      
        const crossPositionVector = vector.clone();
        
        const finalVector = new THREE.Vector2(
            ( crossPositionVector.x * widthHalf ) + widthHalf,
            - ( crossPositionVector.y * heightHalf ) + heightHalf
        );
        
        cb(finalVector, b)
      })
    },
  })
}